/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-underscore-dangle */
import { useEffect, useMemo, useRef, useState } from "react";
// import { deleteCookie, setCookie } from "lib/cookies";
import ActivityTypes from "components/feed/types";
import ActivityOptions from "components/feed/ActivityOptions";
import ActivityFooter from "components/feed/ActivityFooter";
import ActivityType from "types/ActivityType";
import classNames from "lib/classNames";
import UserByline from "components/users/UserByline";
import ActivityLink from "./ActivityLink";
import { deleteCookie, setCookie } from "lib/cookies";

interface ActivityProps {
  activity: ActivityType;
  position?: number;
}

export default function Activity({
  activity,
  position = 0,
}: ActivityProps) {
  const activityRef = useRef<HTMLDivElement>();
  const [deleted, setDeleted] = useState(false);

  const DynamicActivityComponent = useMemo(
    () => ActivityTypes[activity.event],
    [activity.event]
  );

  if (!activity || !activity.event) {
    return <></>;
  }

  const onDelete = () => {
    setDeleted(true);
  };

  // No component exists for this activity. Show nothing.
  if (!DynamicActivityComponent) {
    return <></>;
  }

  function saveLastActivity() {
    deleteCookie(`feed:${window.location.pathname}`);
    setCookie(`feed:${window.location.pathname}`, String(position), 60);
  }
  return (
    <div
      ref={activityRef}
      className={classNames(
        deleted ? "hidden" : "",
        "py-4 sm:py-6 border-b border-stone-300 dark:border-gray-700"
      )}
      onClick={saveLastActivity}
    >
      <div className="text-gray-700 dark:text-gray-400 text-sm flex justify-between items-center">
        <div className="flex flex-row group items-center transition-all">
          <UserByline user={activity.user} />
          <span className="mr-2 hidden md:inline">•</span>
          <p className="hidden md:inline">
            <ActivityLink activity={activity} />
          </p>
        </div>
        <div className="flex flex-row gap-x-4">
          <ActivityOptions activity={activity} onDelete={onDelete} />
        </div>
      </div>
      <DynamicActivityComponent activity={activity} />

      <div className="mt-2">
        <ActivityFooter activity={activity} />
      </div>
    </div>
  );
}
